export default {
    namespaced: true,
    state: {
        bread_active: null,
        bread_list: null,
        singleVideo: null,
        video: [],
        nextPageToken: '',
        pages: [''],
        prefix_: 'https://www.youtube.com/embed/',
    },
    getters: {},
    mutations: {
        SET_DATA(state, data) {
            eval("state." + data.name + " = data.data;");
        },
        videoSet: function (state, payload) {
            if (payload.button === 'prev') {
                state.pages.splice(state.pages.length - 1, 1);
            } else {
                state.pages.push(payload.data.nextPageToken);
            }
            state.video = payload.data.items;
        }
    },
    actions: {
        getData(state, payload) {
            if (payload.pagination === 'next') {
                payload.pagination = '';
            }
            axios.get('/api/v2/pills/realestate/' + payload.pagination)
                .then(response =>{
                    state.commit('videoSet', {data: response.data, button: payload.button});
                    state.commit('SET_DATA', {name: 'singleVideo', data: state.state.prefix_ + response.data.items[0].snippet.resourceId.videoId});

                })
        },

        changeBigVideo(state, payload)
        {
            state.commit('SET_DATA', {name: 'singleVideo', data: state.state.prefix_ + payload.url});
        }
    }
}
